const escapeCsv = (value) => {
  const text = String(value ?? "");
  if (/[",\n]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
};

export const formatAmount = (value) =>
  value == null || value === "" ? "0.00" : Number(value).toFixed(2);

export const formatDate = (value) =>
  value ? new Date(value).toLocaleDateString() : "";

export const flattenJournalEntries = (entries = []) => {
  const rows = [];
  for (const entry of entries) {
    for (const line of entry.lines || []) {
      rows.push({
        _id: `${entry._id}-${line.accountCode}-${rows.length}`,
        entryDate: entry.entryDate,
        journalCode: entry.code,
        description: entry.description,
        sourceType: entry.sourceType,
        eventType: entry.eventType,
        accountCode: line.accountCode,
        accountName: line.accountName,
        lineDescription: line.description,
        debit: line.debit,
        credit: line.credit,
        status: entry.status,
      });
    }
  }
  return rows;
};

export const downloadJournalRegisterCsv = ({
  rows = [],
  periodName = "",
  t,
}) => {
  const lines = [
    [t("accounting.financeReports.journalRegister.title")],
    [t("Fiscal Period"), periodName],
    [],
    [
      t("Date"),
      t("Code"),
      t("Description"),
      t("accounting.journal.source"),
      t("accounting.journal.account"),
      t("Debit"),
      t("Credit"),
    ],
    ...rows.map((row) => [
      formatDate(row.entryDate),
      row.journalCode,
      row.description || row.lineDescription,
      row.sourceType
        ? `${row.sourceType}${row.eventType ? ` / ${row.eventType}` : ""}`
        : "",
      `${row.accountCode} ${row.accountName || ""}`.trim(),
      formatAmount(row.debit),
      formatAmount(row.credit),
    ]),
  ];

  const csv = `\uFEFF${lines.map((line) => line.map(escapeCsv).join(",")).join("\n")}`;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  const stamp = new Date().toISOString().slice(0, 10);
  link.href = url;
  link.download = `journal-register-${periodName || stamp}.csv`;
  link.click();
  URL.revokeObjectURL(url);
};
